import { useCallback, useState } from "react"
import { GetApp } from "../../App"
import { BlockField } from "../../Components/Block"
import { PredefinedSelect } from "../../Components/PredefinedSelect"
import { ShipSingleRowDataItem } from "../../Components/ShipSingleRowDataItem"
import { IShipDataInsurance } from "../../Types"

interface ShipDataInsuranceViewProps {
  data: IShipDataInsurance;
  editable: boolean;
  index: number;
  onEdited?: () => void;
  removeInsurance: () => void;
}

export function ShipDataInsuranceView({ data, editable, index, onEdited, removeInsurance }: ShipDataInsuranceViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const namePrefix = `insurances[${index}].`;

  // Initialize insuranceType with the value from data, or undefined if not present
  const [insuranceType, setInsuranceType] = useState<string | undefined>(data.insuranceType);
  const predefinedTypes = ["liability", "hull", "accident"];

  const selectInsuranceType = useCallback((value?: string) => {
    setInsuranceType(value);
    if (onEdited) {
      onEdited();
    }
  }, []);

  return (
    <ShipSingleRowDataItem namePrefix={namePrefix} id={data.id} rowClassName="one-row-list" onRemove={removeInsurance}>
      <BlockField label={t("insurance_type")} className="block_field_small_16">
        <PredefinedSelect value={insuranceType} predefined={predefinedTypes} label={(v) => t(`insurance_${v}`)} customValue={t("other")} name={`${namePrefix}insuranceType`} onSelect={selectInsuranceType} readOnly={!editable} />
      </BlockField>

      <BlockField label={t("insurance_company")} className="block_field_mobile_full">
        <input name={`${namePrefix}insuranceCompany`} defaultValue={data.insuranceCompany} onChange={onEdited} readOnly={!editable} />
      </BlockField>
      <BlockField label={t("insurance_number")} className="block_field_small_16">
        <input name={`${namePrefix}insuranceNumber`} defaultValue={data.insuranceNumber} onChange={onEdited} readOnly={!editable} />
      </BlockField>
    </ShipSingleRowDataItem>
  );
}
